import { httpService } from "@/services/http.service";
import { Difficulty, listPageItem, singleExercise } from "@/types/singleExercises";
import { Action, Module, Mutation, VuexModule } from "vuex-class-modules";
import store from '../index'
import Vue from "vue";
import { CACHE_SECTION } from "@/services/cache.service";

@Module
class SingleExerciseModule extends VuexModule {
    private exerciseList: singleExercise[] = []
    private hashMap: Map<string, number[]> = new Map()
    private filterList: string[] = []
    private selectedFilters: string[] = []
    private list: listPageItem[] = []
    private newPhraze = ''
    private activeExerciseId = ''

    get exercises() { return this.exerciseList }
    get filters() { return this.filterList }
    get activeFilters() { return this.selectedFilters }
    get listItems() { return this.list} 
    get hashMapItems() { return this.hashMap }
    get searchPhraze() { return this.newPhraze }
    get activeExercise() { return this.activeExerciseId }


    @Mutation
    setExercises(exercises: singleExercise[]) {
        this.exerciseList = exercises
    }

    @Mutation
    setFilterTypes() {
        const filters = new Set<string>()
        this.list = this.exerciseList.map((item) => {
            const searchableTags: string[] = []
            const tagsArray: string[] = [] 
            let level: Difficulty = '' as Difficulty
            
            if (item.equipment_name) {
                searchableTags.push(`equipment-${item.equipment_name.toLowerCase()}`)
                filters.add(`equipment-${item.equipment_name.toLowerCase()}`)
                tagsArray.push(item.equipment_name.toLowerCase())
            }

            if (item["MG1"]) {
                const muscleGroups = []
                muscleGroups.push(item["MG1"] ?? '')
                muscleGroups.push(item["MG2"] ?? '')
                muscleGroups.push(item["MG3"] ?? '')
                muscleGroups.push(item["MG4"] ?? '')
                muscleGroups.forEach((muscleGroup: string) => {
                    if (muscleGroup) {
                    searchableTags.push(`muscleGroup-${muscleGroup.toLowerCase()}`)
                    filters.add(`muscleGroup-${muscleGroup.toLowerCase()}`)
                    tagsArray.push(muscleGroup.toLowerCase())
                    }
                })
            }

            if (item.level) {
                if (item.level === Difficulty.BEGINNER) level = Difficulty.BEGINNER
                if (item.level === Difficulty.INTERMEDIATE) level = Difficulty.INTERMEDIATE
                if (item.level === Difficulty.ADVANCED) level = Difficulty.ADVANCED
            }

            return {
                name: item.title_new.toString(),
                thumbnail: '',
                tags: tagsArray,
                id: item.mp4,
                search: searchableTags,
                type: item["exercise_type-1"],
                difficulty: level,
                category: item.category
            }
        })

        this.filterList = [...filters]
    }

    @Mutation
    buildHashMap() {
        const searchMap = new Map<string, number[]>()

        for (let i = 0; i < this.list.length; i++) {
            const exercise = this.list[i]
            for (const search of exercise.search) {
                if (!searchMap.has(search.toLocaleLowerCase())) {
                    searchMap.set(search.toLocaleLowerCase(), [])
                }
                searchMap.get(search.toLocaleLowerCase())!.push(i)
            }
        }
        this.hashMap = searchMap
    }

    @Mutation
    setFilter(filter: string): void {
      const isDuplicate = this.selectedFilters.includes(filter)
      if (!isDuplicate) {
        this.selectedFilters.push(filter)
      } else {
        this.selectedFilters = this.selectedFilters.filter((selected: string) => selected !== filter)
      }
    }

    @Mutation
    setSearch(phraze: string) {
        this.newPhraze = phraze
    }

    @Mutation
    setClear() {
        this.selectedFilters = []
        this.newPhraze = ''
        this.activeExerciseId = ''
    }

    @Mutation
    setActiveExercise(id: string) {
        this.activeExerciseId = id
    }

    @Action
    addFilter(filter: string): void {
        this.setFilter(filter)
    }

    @Action
    async cacheExercises() {
        this.list.map(async(exercise: listPageItem) => {
            try {
                await Vue.prototype.$cacheService.match(CACHE_SECTION.EXERCISES ,`./exercises/${exercise.category}/${exercise.id}.png`)
            } catch(err) {
                // eslint-disable-next-line
                console.log('err: ', err)
            }
        })
    }

    @Action
    async getExercises() {
        const exercises = await httpService.exerciseList()
        this.setExercises(exercises)
        this.setFilterTypes()
        this.cacheExercises()
        this.buildHashMap()
    }

    @Action
    search(phraze: string) {
        this.setSearch(phraze)
    }

    @Action
    getActiveExercise(id: string) {
        this.setActiveExercise(id)
    }

    @Action
    clearAll() {
        this.setClear()
    }

}

export default new SingleExerciseModule({ store, name: 'singleExersiceModule' })